var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7018 156.472H44.1441C38.7441 160.265 34.0643 164.49 30.5416 168.94C30.1757 169.403 29.8191 169.872 29.4722 170.349H52.8386C53.1591 169.865 53.5007 169.395 53.8623 168.94C58.21 163.447 66.0358 158.702 73.7018 156.472Z",
    fill: "url(#paint0_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7018 156.472H44.1441C38.7441 160.265 34.0643 164.49 30.5416 168.94C30.1757 169.403 29.8191 169.872 29.4722 170.349H52.8386C53.1591 169.865 53.5007 169.395 53.8623 168.94C58.21 163.447 66.0358 158.702 73.7018 156.472Z",
    fill: "#FE9738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6354 176H29.189C27.1932 176 25.5752 174.382 25.5752 172.386C25.5752 170.677 26.7718 169.202 28.4438 168.85L30.3489 168.449C38.3038 166.772 46.521 166.772 54.476 168.449L56.381 168.85C57.1923 169.021 57.92 169.466 58.4423 170.109C58.9646 170.753 59.2496 171.557 59.2496 172.386C59.2496 174.382 57.6316 176 55.6354 176Z",
    fill: "url(#paint1_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5752 172.386C25.5752 174.382 27.1932 176 29.189 176H55.6354C57.6313 176 59.2493 174.382 59.2493 172.386C59.2493 171.347 58.8052 170.397 58.0829 169.73H26.7415C26.374 170.068 26.0805 170.479 25.8797 170.936C25.679 171.393 25.5753 171.887 25.5752 172.386Z",
    fill: "#FE9738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.138 168.94C122.499 169.395 122.841 169.865 123.162 170.349H146.528C146.181 169.872 145.824 169.403 145.459 168.94C141.936 164.489 137.256 160.265 131.856 156.472H102.298C109.964 158.702 117.79 163.447 122.138 168.94Z",
    fill: "#FE9738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.138 168.94C122.499 169.395 122.841 169.865 123.162 170.349H146.528C146.181 169.872 145.824 169.403 145.459 168.94C141.936 164.489 137.256 160.265 131.856 156.472H102.298C109.964 158.702 117.79 163.447 122.138 168.94Z",
    fill: "url(#paint2_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.811 176H120.364C118.369 176 116.75 174.382 116.75 172.386C116.75 170.677 117.947 169.202 119.619 168.85L121.524 168.449C129.479 166.772 137.696 166.772 145.651 168.449L147.556 168.85C148.431 169.034 149.206 169.536 149.732 170.258C150.258 170.981 150.498 171.872 150.405 172.761C150.313 173.65 149.894 174.473 149.23 175.071C148.566 175.669 147.704 176 146.811 176Z",
    fill: "url(#paint3_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 172.386C116.75 174.382 118.368 176 120.364 176H146.81C148.806 176 150.424 174.382 150.424 172.386C150.424 171.347 149.98 170.397 149.258 169.73H117.916C117.549 170.068 117.255 170.479 117.055 170.936C116.854 171.393 116.75 171.887 116.75 172.386Z",
    fill: "#FE9738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.142 31.9973L121.945 23.8006C120.127 21.9828 119.126 19.5656 119.126 16.9943C119.126 13.772 116.504 11.1502 113.282 11.1502H105.791C100.094 11.1502 94.737 8.93166 90.708 4.90291C89.984 4.17966 89.0229 3.78125 88.0002 3.78125C86.9776 3.78125 86.0165 4.17966 85.2932 4.90291C81.2641 8.932 75.9075 11.1506 70.2105 11.1506H62.7191C59.4965 11.1506 56.875 13.7723 56.875 16.9947C56.875 19.5656 55.8737 21.9832 54.056 23.8009L45.8592 31.9976L43.1855 29.3243L51.3823 21.1276C51.9266 20.5861 52.3581 19.942 52.6519 19.2327C52.9457 18.5233 53.0959 17.7628 53.0938 16.995C53.0938 11.6878 57.412 7.36966 62.7191 7.36966H70.2105C74.8975 7.36966 79.3047 5.544 82.6195 2.22956C84.0564 0.792 85.9676 0 88.0002 0C90.0328 0 91.9441 0.792 93.3813 2.22922C96.6961 5.54366 101.103 7.36897 105.79 7.36897H113.282C118.589 7.36897 122.907 11.6872 122.907 16.9943C122.907 18.5553 123.515 20.0231 124.619 21.1269L132.815 29.3236L130.142 31.9973Z",
    fill: "url(#paint4_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0001 173.944C127.708 173.944 159.898 141.754 159.898 102.046C159.898 62.3373 127.708 30.1475 88.0001 30.1475C48.2919 30.1475 16.1021 62.3373 16.1021 102.046C16.1021 141.754 48.2919 173.944 88.0001 173.944Z",
    fill: "url(#paint5_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 161.664C120.926 161.664 147.619 134.972 147.619 102.045C147.619 69.1189 120.926 42.4268 88 42.4268C55.0735 42.4268 28.3813 69.1189 28.3813 102.045C28.3813 134.972 55.0735 161.664 88 161.664Z",
    fill: "url(#paint6_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0001 173.944C127.708 173.944 159.898 141.754 159.898 102.046C159.898 62.3373 127.708 30.1475 88.0001 30.1475C48.2919 30.1475 16.1021 62.3373 16.1021 102.046C16.1021 141.754 48.2919 173.944 88.0001 173.944Z",
    fill: "#FE9738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1021 102.046C16.1021 141.753 48.2918 173.944 88.0001 173.944C127.708 173.944 159.898 141.753 159.898 102.046C159.898 93.4456 158.383 85.2011 155.614 77.5571H20.3859C17.617 85.2011 16.1021 93.4459 16.1021 102.046Z",
    fill: "url(#paint7_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1606 152.886C65.2385 180.963 110.762 180.964 138.84 152.886C166.918 124.808 166.918 79.2839 138.84 51.206C132.759 45.1251 125.858 40.3666 118.495 36.9194L22.874 132.54C26.3211 139.903 31.0793 146.804 37.1606 152.886Z",
    fill: "url(#paint8_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0002 152.445C115.835 152.445 138.4 129.881 138.4 102.046C138.4 74.2107 115.835 51.646 88.0002 51.646C60.1653 51.646 37.6006 74.2107 37.6006 102.046C37.6006 129.881 60.1653 152.445 88.0002 152.445Z",
    fill: "url(#paint9_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4 102.046C138.4 74.2108 115.835 51.646 88.0002 51.646C60.1654 51.646 37.6006 74.2108 37.6006 102.046C37.6006 108.074 38.6624 113.853 40.6036 119.211H135.397C137.338 113.853 138.4 108.074 138.4 102.046Z",
    fill: "url(#paint10_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.638 66.4077C103.956 46.7256 72.0446 46.7253 52.3622 66.4077C32.6801 86.0898 32.6801 118.001 52.3622 137.684C56.625 141.946 61.4622 145.282 66.6237 147.698L133.653 80.6695C131.236 75.5081 127.901 70.6705 123.638 66.4077Z",
    fill: "url(#paint11_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.083 55.5588L153.996 73.4723C150.64 65.7135 145.847 58.4287 139.627 52.0137L136.083 55.5588Z",
    fill: "url(#paint12_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.108 26.626C178.584 39.102 179.364 58.5497 167.85 70.064C156.335 81.5782 111.156 36.3985 122.67 24.8842C134.184 13.37 153.632 14.1499 166.108 26.626Z",
    fill: "url(#paint13_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85 70.064C179.364 58.5501 178.584 39.1021 166.108 26.626C162.564 23.082 158.456 20.4842 154.128 18.8418L127.525 45.4446C138.636 61.0598 160.361 77.5526 167.85 70.064Z",
    fill: "url(#paint14_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 24.8846C122.525 25.03 122.395 25.1843 122.268 25.34L167.394 70.4668C167.55 70.3393 167.704 70.2097 167.85 70.0643C179.364 58.5504 178.584 39.1024 166.108 26.6263C153.632 14.1503 134.184 13.3706 122.67 24.8846Z",
    fill: "url(#paint15_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8921 26.6263C-2.58396 39.1024 -3.36393 58.5501 8.15032 70.0643C19.6646 81.5786 64.844 36.3985 53.3301 24.8846C41.8162 13.3706 22.3682 14.1503 9.8921 26.6263Z",
    fill: "url(#paint16_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15018 70.064C-3.36373 58.5501 -2.5841 39.1021 9.89196 26.626C13.436 23.082 17.5435 20.4842 21.8717 18.8418L48.4745 45.4446C37.3634 61.0598 15.6388 77.5526 8.15018 70.064Z",
    fill: "url(#paint17_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3299 24.8846C53.4753 25.03 53.6053 25.1843 53.7325 25.34L8.60565 70.4668C8.44722 70.3403 8.29521 70.206 8.15018 70.0643C-3.36373 58.5504 -2.5841 39.1024 9.89196 26.6263C22.368 14.1503 41.8157 13.3706 53.3299 24.8846Z",
    fill: "url(#paint18_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9999 57.7852C87.5301 57.7852 87.0795 57.9718 86.7473 58.304C86.4151 58.6362 86.2285 59.0867 86.2285 59.5565V66.3854C86.2285 66.8552 86.4151 67.3058 86.7473 67.638C87.0795 67.9702 87.5301 68.1568 87.9999 68.1568C88.4696 68.1568 88.9202 67.9702 89.2524 67.638C89.5846 67.3058 89.7712 66.8552 89.7712 66.3854V59.5565C89.7712 59.0867 89.5846 58.6362 89.2524 58.304C88.9202 57.9718 88.4696 57.7852 87.9999 57.7852Z",
    fill: "url(#paint19_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9999 135.935C87.7672 135.935 87.5369 135.981 87.322 136.07C87.1071 136.159 86.9118 136.289 86.7473 136.454C86.5828 136.618 86.4524 136.814 86.3633 137.029C86.2743 137.243 86.2285 137.474 86.2285 137.706V144.535C86.2285 145.005 86.4151 145.456 86.7473 145.788C87.0795 146.12 87.5301 146.307 87.9999 146.307C88.4696 146.307 88.9202 146.12 89.2524 145.788C89.5846 145.456 89.7712 145.005 89.7712 144.535V137.706C89.7712 137.474 89.7254 137.243 89.6364 137.029C89.5473 136.814 89.4169 136.618 89.2524 136.454C89.0879 136.289 88.8926 136.159 88.6777 136.07C88.4628 135.981 88.2325 135.935 87.9999 135.935Z",
    fill: "url(#paint20_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.489 100.274H123.66C123.428 100.274 123.198 100.32 122.983 100.409C122.768 100.498 122.572 100.629 122.408 100.793C122.243 100.958 122.113 101.153 122.024 101.368C121.935 101.583 121.889 101.813 121.889 102.046C121.889 102.278 121.935 102.509 122.024 102.724C122.113 102.939 122.243 103.134 122.408 103.298C122.572 103.463 122.768 103.593 122.983 103.682C123.198 103.771 123.428 103.817 123.66 103.817H130.489C130.722 103.817 130.952 103.771 131.167 103.682C131.382 103.593 131.577 103.463 131.742 103.298C131.906 103.134 132.037 102.939 132.126 102.724C132.215 102.509 132.261 102.278 132.261 102.046C132.261 101.813 132.215 101.583 132.126 101.368C132.037 101.153 131.906 100.958 131.742 100.793C131.577 100.629 131.382 100.498 131.167 100.409C130.952 100.32 130.722 100.274 130.489 100.274Z",
    fill: "url(#paint21_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2892 64.3632C68.1729 64.1617 68.018 63.9852 67.8335 63.8436C67.6489 63.702 67.4383 63.5981 67.2136 63.5379C66.9889 63.4777 66.7546 63.4623 66.524 63.4927C66.2933 63.5231 66.071 63.5986 65.8695 63.7149C65.6681 63.8312 65.4915 63.986 65.3499 64.1706C65.2083 64.3551 65.1044 64.5657 65.0442 64.7904C64.984 65.0151 64.9687 65.2494 64.999 65.4801C65.0294 65.7107 65.1049 65.9331 65.2212 66.1345L68.6357 72.0487C68.752 72.2502 68.9068 72.4267 69.0914 72.5683C69.2759 72.71 69.4865 72.8138 69.7112 72.874C69.9359 72.9342 70.1703 72.9496 70.4009 72.9192C70.6315 72.8888 70.8539 72.8134 71.0553 72.697C71.2568 72.5807 71.4333 72.4259 71.5749 72.2413C71.7165 72.0568 71.8204 71.8462 71.8806 71.6215C71.9408 71.3968 71.9562 71.1625 71.9258 70.9318C71.8954 70.7012 71.82 70.4788 71.7036 70.2774L68.2892 64.3632Z",
    fill: "url(#paint22_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.364 132.043C107.248 131.841 107.093 131.665 106.908 131.523C106.724 131.382 106.513 131.278 106.288 131.218C106.064 131.157 105.829 131.142 105.599 131.172C105.368 131.203 105.146 131.278 104.944 131.395C104.743 131.511 104.566 131.666 104.425 131.85C104.283 132.035 104.179 132.245 104.119 132.47C104.059 132.695 104.043 132.929 104.074 133.16C104.104 133.39 104.18 133.613 104.296 133.814L107.71 139.728C107.827 139.93 107.982 140.106 108.166 140.248C108.351 140.39 108.561 140.494 108.786 140.554C109.011 140.614 109.245 140.629 109.476 140.599C109.706 140.569 109.929 140.493 110.13 140.377C110.331 140.26 110.508 140.106 110.65 139.921C110.791 139.736 110.895 139.526 110.955 139.301C111.016 139.076 111.031 138.842 111.001 138.612C110.97 138.381 110.895 138.159 110.778 137.957L107.364 132.043Z",
    fill: "url(#paint23_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.769 85.7495L125.683 82.3351C125.884 82.2188 126.061 82.0639 126.202 81.8794C126.344 81.6948 126.448 81.4842 126.508 81.2595C126.568 81.0348 126.584 80.8005 126.553 80.5699C126.523 80.3392 126.447 80.1169 126.331 79.9154C126.215 79.714 126.06 79.5374 125.875 79.3958C125.691 79.2542 125.48 79.1503 125.255 79.0901C125.031 79.0299 124.796 79.0146 124.566 79.0449C124.335 79.0753 124.113 79.1508 123.911 79.2671L117.997 82.6816C117.594 82.9181 117.3 83.3047 117.18 83.7569C117.061 84.2092 117.125 84.6903 117.359 85.0954C117.593 85.5005 117.977 85.7967 118.429 85.9192C118.88 86.0418 119.362 85.9808 119.769 85.7495Z",
    fill: "url(#paint24_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2312 118.342L50.317 121.757C49.9134 121.993 49.6198 122.38 49.5003 122.832C49.3807 123.284 49.4448 123.766 49.6787 124.171C49.9126 124.576 50.2973 124.872 50.7487 124.994C51.2001 125.117 51.6817 125.056 52.0883 124.825L58.0025 121.41C58.204 121.294 58.3806 121.139 58.5222 120.955C58.6638 120.77 58.7676 120.559 58.8278 120.335C58.888 120.11 58.9034 119.876 58.873 119.645C58.8427 119.414 58.7672 119.192 58.6509 118.991C58.5346 118.789 58.3797 118.613 58.1952 118.471C58.0106 118.329 57.8 118.226 57.5753 118.165C57.3506 118.105 57.1163 118.09 56.8857 118.12C56.655 118.151 56.4326 118.226 56.2312 118.342Z",
    fill: "url(#paint25_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.13 63.7149C109.723 63.48 109.24 63.4163 108.786 63.5379C108.332 63.6595 107.945 63.9563 107.71 64.3632L104.296 70.2774C104.065 70.684 104.004 71.1656 104.126 71.617C104.249 72.0685 104.545 72.4531 104.95 72.687C105.355 72.9209 105.836 72.985 106.289 72.8654C106.741 72.7459 107.127 72.4523 107.364 72.0487L110.778 66.1345C110.895 65.9331 110.97 65.7107 111.001 65.4801C111.031 65.2494 111.016 65.0151 110.956 64.7904C110.895 64.5657 110.791 64.355 110.65 64.1705C110.508 63.986 110.332 63.8311 110.13 63.7149Z",
    fill: "url(#paint26_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0554 131.395C70.854 131.278 70.6316 131.203 70.401 131.172C70.1703 131.142 69.936 131.157 69.7113 131.218C69.4866 131.278 69.2759 131.382 69.0914 131.523C68.9069 131.665 68.752 131.841 68.6358 132.043L65.2213 137.957C64.9901 138.364 64.9291 138.845 65.0516 139.297C65.1742 139.748 65.4703 140.133 65.8754 140.367C66.2805 140.601 66.7617 140.665 67.2139 140.545C67.6661 140.426 68.0527 140.132 68.2892 139.729L71.7037 133.814C71.8201 133.613 71.8956 133.39 71.926 133.16C71.9564 132.929 71.941 132.695 71.8808 132.47C71.8206 132.245 71.7167 132.035 71.5751 131.85C71.4335 131.666 71.2569 131.511 71.0554 131.395Z",
    fill: "url(#paint27_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0028 82.6816L52.0886 79.2671C51.8872 79.1508 51.6648 79.0753 51.4342 79.0449C51.2035 79.0146 50.9692 79.0299 50.7445 79.0901C50.5198 79.1503 50.3092 79.2542 50.1247 79.3958C49.9401 79.5374 49.7853 79.714 49.669 79.9154C49.5527 80.1169 49.4772 80.3392 49.4468 80.5699C49.4164 80.8005 49.4318 81.0348 49.492 81.2595C49.5522 81.4842 49.6561 81.6948 49.7977 81.8794C49.9393 82.0639 50.1158 82.2188 50.3173 82.3351L56.2315 85.7495C56.6381 85.9808 57.1197 86.0418 57.5711 85.9192C58.0226 85.7967 58.4072 85.5005 58.6411 85.0954C58.875 84.6903 58.9391 84.2092 58.8196 83.7569C58.7 83.3047 58.4064 82.9181 58.0028 82.6816Z",
    fill: "url(#paint28_linear_355_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.683 121.756L119.768 118.342C119.362 118.111 118.88 118.05 118.429 118.172C117.977 118.295 117.593 118.591 117.359 118.996C117.125 119.401 117.061 119.882 117.18 120.334C117.3 120.787 117.594 121.173 117.997 121.41L123.911 124.824C124.113 124.941 124.335 125.016 124.566 125.046C124.796 125.077 125.031 125.061 125.255 125.001C125.48 124.941 125.691 124.837 125.875 124.696C126.06 124.554 126.215 124.377 126.331 124.176C126.447 123.975 126.523 123.752 126.553 123.522C126.584 123.291 126.568 123.057 126.508 122.832C126.448 122.607 126.344 122.397 126.202 122.212C126.061 122.028 125.884 121.873 125.683 121.756Z",
    fill: "url(#paint29_linear_355_62)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_62",
    x1: 45.3483,
    y1: 157.876,
    x2: 51.3024,
    y2: 163.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_355_62",
    x1: 46.6195,
    y1: 171.436,
    x2: 52.9613,
    y2: 163.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_355_62",
    x1: 129.939,
    y1: 163.16,
    x2: 140.112,
    y2: 152.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_355_62",
    x1: 137.795,
    y1: 171.436,
    x2: 144.137,
    y2: 163.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_355_62",
    x1: 88.0002,
    y1: 2.01163,
    x2: 88.0002,
    y2: 20.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_355_62",
    x1: 44.0207,
    y1: 58.0665,
    x2: 123.357,
    y2: 137.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_355_62",
    x1: 102.897,
    y1: 99.8907,
    x2: 153.214,
    y2: 83.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_355_62",
    x1: 105.965,
    y1: 124.009,
    x2: 160.548,
    y2: 98.2211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_355_62",
    x1: 108.505,
    y1: 102.956,
    x2: 166.329,
    y2: 84.6442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_355_62",
    x1: 118.829,
    y1: 132.874,
    x2: 63.2155,
    y2: 77.2612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_355_62",
    x1: 82.2341,
    y1: 85.1685,
    x2: 70.0733,
    y2: 49.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_355_62",
    x1: 63.2487,
    y1: 90.1629,
    x2: 40.7283,
    y2: 79.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_355_62",
    x1: 144.106,
    y1: 73.913,
    x2: 145.331,
    y2: 61.5789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#F90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#EA035B",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#D20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_355_62",
    x1: 147.966,
    y1: 28.5616,
    x2: 149.288,
    y2: 62.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_355_62",
    x1: 152.259,
    y1: 54.5382,
    x2: 153.393,
    y2: 71.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_355_62",
    x1: 155.847,
    y1: 42.6296,
    x2: 178.522,
    y2: 35.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_355_62",
    x1: 28.0345,
    y1: 28.562,
    x2: 26.7118,
    y2: 62.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_355_62",
    x1: 23.7406,
    y1: 54.5382,
    x2: 22.6069,
    y2: 71.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_355_62",
    x1: 20.1536,
    y1: 42.6296,
    x2: -2.52154,
    y2: 35.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_355_62",
    x1: 281.351,
    y1: 195.541,
    x2: 52.9826,
    y2: 38.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_355_62",
    x1: 244.902,
    y1: 248.7,
    x2: 16.534,
    y2: 92.1204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_355_62",
    x1: 275.622,
    y1: 203.895,
    x2: 47.2535,
    y2: 47.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_355_62",
    x1: 272.662,
    y1: 208.214,
    x2: 44.2934,
    y2: 51.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_355_62",
    x1: 253.591,
    y1: 236.026,
    x2: 25.2231,
    y2: 79.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_355_62",
    x1: 283.06,
    y1: 193.048,
    x2: 54.6915,
    y2: 36.4685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_355_62",
    x1: 243.193,
    y1: 251.193,
    x2: 14.8247,
    y2: 94.6137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_355_62",
    x1: 285.156,
    y1: 189.989,
    x2: 56.7883,
    y2: 33.4104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_355_62",
    x1: 241.096,
    y1: 254.251,
    x2: 12.7283,
    y2: 97.6717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_355_62",
    x1: 261.418,
    y1: 224.613,
    x2: 33.0493,
    y2: 68.0338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_355_62",
    x1: 264.836,
    y1: 219.627,
    x2: 36.4675,
    y2: 63.0481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFrame);
export default __webpack_public_path__ + "static/media/clockFrame.68193844255765fced2d989b2d8a4950.svg";
export { ForwardRef as ReactComponent };